import { createBrowserRouter, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { RootLayout } from "./pages/RootLayout";

const ProductListPage = lazy(() =>
  import("./pages/ProductListPage").then((m) => ({ default: m.ProductListPage }))
);
const ProductDetailPage = lazy(() =>
  import("./pages/ProductDetailPage").then((m) => ({ default: m.ProductDetailPage }))
);
const LoginPage = lazy(() =>
  import("./pages/LoginPage").then((m) => ({ default: m.LoginPage }))
);
const AccountPage = lazy(() =>
  import("./pages/AccountPage").then((m) => ({ default: m.AccountPage }))
);
const NotFoundPage = lazy(() =>
  import("./pages/NotFoundPage").then((m) => ({ default: m.NotFoundPage }))
);

const Fallback = () => (
  <div className="p-8 text-center text-gray-500" role="status" aria-live="polite">
    Laden…
  </div>
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: (
      <div className="p-8 text-center text-red-600" role="alert">
        Er ging iets mis bij het laden van de pagina.
      </div>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Fallback />}>
            <ProductListPage />
          </Suspense>
        ),
      },
      {
        path: "p/:slug",
        element: (
          <Suspense fallback={<Fallback />}>
            <ProductDetailPage />
          </Suspense>
        ),
      },
      {
        path: "login",
        element: (
          <Suspense fallback={<Fallback />}>
            <LoginPage />
          </Suspense>
        ),
      },
      {
        path: "account",
        element: (
          <Suspense fallback={<Fallback />}>
            <AccountPage />
          </Suspense>
        ),
      },
      {
        path: "*",
        element: (
          <Suspense fallback={<Fallback />}>
            <NotFoundPage />
          </Suspense>
        ),
      },
      { path: "404", element: <Navigate to="/" replace /> },
    ],
  },
]);
